// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__nUrec","spinner":"styles_spinner__7zOCw","spin":"styles_spin__3ODrb"};